requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xQuickView', {
      sectionId: window.xQuickView.sectionId,
      enabled: window.xQuickView.enabled,
      buttonLabel: window.xQuickView.buttonLabel,
      show_atc_button: window.xQuickView.show_atc_button,
      btn_atc_bottom: window.xQuickView.atc_btn_bottom,
      atc_btn_image_desktop: window.xQuickView.atc_btn_image_desktop,
      show: false,
      loading: false,
      currentVariant: '',
      cachedResults: [],
      cachedfetch: [],
      loadingUrls: [],
      loadRequestId: 0,
      loadedChooseOptions: [],
      loadedChooseOptionsID: [],
      selected: false,
      loadingChooseOption: false,
      isMiniCart: false,
      openPopupMobile: false,
      buttonQuickView: "",
      triggerElement: null,
      chooseOptionsTrigger: null,
      listenersAdded: false,
      touchStartX: 0,
      touchStartY: 0,
      touchStartHandler: null,
      touchMoveHandler: null,
      touchLockElement: null,
      addListener() {
        if (this.listenersAdded) return;
        this.listenersAdded = true;
        document.addEventListener('eurus:cart:items-changed', () => {
          this.cachedResults = [];
        });
        window.addEventListener('resize', () => this.syncBuyButtonsPlacement());
      },
      showBtn(enable, showATCButton, textBtn) {
        this.enabled = enable;
        this.buttonLabel = textBtn;
        this.show_atc_button = showATCButton;
      },
      resetScrollPosition() {
        const content = document.querySelector('#QuickView .x-container-quickview-content');
        if (content) content.scrollTop = 0;
      },
      clearMobileFooter() {
        const footer = document.getElementById('QuickViewMobileFooter');
        if (footer) footer.replaceChildren();
      },
      syncBuyButtonsPlacement() {
        const footer = document.getElementById('QuickViewMobileFooter');
        const content = document.getElementById('quickview-product-content');
        if (!footer || !content) return;

        const anchor = content.querySelector('.quickview-buy-buttons-anchor');
        if (window.matchMedia('(max-width: 767px)').matches) {
          // Content is authoritative after a Quick View response is inserted. If a
          // previous footer node survives a rapid product change, replacing it here
          // prevents the old form and the current form from being shown together.
          const buyButtons = content.querySelector('.x-block-buy-buttons')
            || footer.querySelector('.x-block-buy-buttons');
          if (buyButtons && buyButtons.parentElement !== footer) {
            footer.replaceChildren(buyButtons);
          }
        } else {
          const buyButtons = footer.querySelector('.x-block-buy-buttons')
            || content.querySelector('.x-block-buy-buttons');
          if (anchor && buyButtons && buyButtons.parentElement === footer) {
            anchor.after(buyButtons);
          }
        }
      },
      notifyProductLoaded(productUrl) {
        this.resetScrollPosition();
        requestAnimationFrame(() => {
          this.syncBuyButtonsPlacement();
          document.dispatchEvent(new CustomEvent("eurus:quickview:loaded", {
            detail: {
              productUrl
            }
          }));
        });
      },
      load(url, el, optionId) {
        this.loading = true;
        this.resetScrollPosition();
        this.clearMobileFooter();

        requestAnimationFrame(() => {
          setTimeout(() => { 
            this.buttonQuickView = el;
            let variant = document.getElementById('current-variant-' + optionId)?.innerText;
            let productUrl = variant?`${url}?variant=${variant}&section_id=${this.sectionId}`:`${url}?section_id=${this.sectionId}`;
            productUrl = productUrl.replace(/\s+/g, '');

            if (this.cachedResults[productUrl]) {
              this.loadRequestId += 1;
              Alpine.store('xHelper').cancelRequest('eurus:quick_view_request');
              document.getElementById('quickview-product-content').innerHTML = this.cachedResults[productUrl];
              this.loading = false;
              this.notifyProductLoaded(url);
              return true;
            }
            
            if (this.cachedfetch[productUrl]) {
              return true;
            }

            this.cachedfetch[productUrl] = true;
            const requestId = ++this.loadRequestId;
            Alpine.store('xHelper').cancelRequest('eurus:quick_view_request');
            const controller = new AbortController();
            Alpine.store('xHelper').requestControllers.set('eurus:quick_view_request', controller);

            fetch(productUrl, { signal: controller.signal })
              .then(response => {
                if (!response.ok) {
                  throw new Error(`Quick View request failed with status ${response.status}`);
                }
                return response.text();
              })
              .then((response) => {
                const parser = new DOMParser();
                const source = parser.parseFromString(response, 'text/html').getElementById('quickview-product-content');
                if (!source) {
                  throw new Error('Quick View response did not include the expected product content');
                }
                if (requestId !== this.loadRequestId) return;

                const destination = document.getElementById('quickview-product-content');
                if (!destination) return;

                const content = source.innerHTML;
                destination.innerHTML = content;
                this.cachedResults[productUrl] = content;
                this.notifyProductLoaded(url);
              })
              .catch((error) => {
                if (error.name !== 'AbortError') {
                  console.error(error);
                }
              })
              .finally(() => {
                this.cachedfetch[productUrl] = false;
                if (requestId === this.loadRequestId) {
                  this.loading = false;
                }
              })

            return true;
          }, 0)
        });
      },
      async loadChooseOptions(url, el, optionId, index) {
        setTimeout(async () => { 
          let getVariant = document.getElementById('current-variant-' + optionId)?.innerText;
          let urlProduct = `${url}?section_id=choose-option&page=${index}`;
          
          let destinationElm = document.getElementById('choose-options-' + optionId)?.querySelector('.choose-options');
          let destinationElmMobile = document.getElementById('choose-options-mobile');
          let loadingEl = document.getElementById('choose-options-' + optionId)?.querySelector('.icon-loading');
          
          if (this.loadedChooseOptions[urlProduct]) {
            if (window.xViewport.innerWidth > 767) {
              if (!el.closest('.card-product').querySelector('#choose-options-' + optionId)?.querySelector('.choose-options-content')) {
                destinationElm && (destinationElm.innerHTML = this.loadedChooseOptions[urlProduct]);
                destinationElmMobile && (destinationElmMobile.innerHTML = '');  
              }
              if (destinationElm) {
                if (destinationElm.querySelector(".add_to_cart_button")) {
                  destinationElm.querySelector(".add_to_cart_button").style.display="block";
                }
                if (destinationElm.querySelector(".label-btn-quickview")) {
                  destinationElm.querySelector(".label-btn-quickview").style.display="none";
                }
              }
            } else {
              if (!el.closest('.card-product').querySelector('#choose-options-mobile')) {
                destinationElmMobile && (destinationElmMobile.innerHTML = this.loadedChooseOptions[urlProduct]);
                destinationElm && (destinationElm.innerHTML = '');
              }
              if (destinationElmMobile) {
                if (destinationElmMobile.querySelector(".add_to_cart_button")) {
                  destinationElmMobile.querySelector(".add_to_cart_button").style.display="block";
                }
                if (destinationElmMobile.querySelector(".label-btn-quickview")) {
                  destinationElmMobile.querySelector(".label-btn-quickview").style.display="none";
                }
              }
            }
            return true;
          }
          
          try {
            if (loadingEl) {
              loadingEl.classList.remove('hidden');
            }
            this.loadingChooseOption = true;
            if (!this.loadingUrls.includes(urlProduct)) {
              this.loadingUrls.push(urlProduct);
              await fetch(urlProduct).then((response) => response.text()).then((content) => {
                const parser = new DOMParser();
                const parsedContent = parser.parseFromString(content, 'text/html').getElementById("choose-options-content").innerHTML;
                
                if (parsedContent) {
                  if (window.xViewport.innerWidth > 767) {
                    destinationElmMobile && (destinationElmMobile.innerHTML = '');
                    destinationElm && (destinationElm.innerHTML = parsedContent);
                  } else {
                    destinationElmMobile && (destinationElmMobile.innerHTML = parsedContent);
                    destinationElm && (destinationElm.innerHTML = '');
                  }
                  this.loadedChooseOptions[urlProduct] = parsedContent;
                }
                if (loadingEl) {
                  loadingEl.classList.add('hidden');
                }  
              }).finally(() => {
                const index = this.loadingUrls.indexOf(urlProduct);
                if (index !== -1) this.loadingUrls.splice(index, 1);  
                if (window.xViewport.innerWidth > 767) {
                  if (destinationElm) {
                    if (destinationElm.querySelector(".add_to_cart_button")) {
                      destinationElm.querySelector(".add_to_cart_button").style.display="block";
                    }
                    if (destinationElm.querySelector(".label-btn-quickview")) {
                      destinationElm.querySelector(".label-btn-quickview").style.display="none";
                    }
                  }
                } else {
                  if (destinationElmMobile) {
                    if (destinationElmMobile.querySelector(".add_to_cart_button")) {
                      destinationElmMobile.querySelector(".add_to_cart_button").style.display="block";
                    }
                    if (destinationElmMobile.querySelector(".label-btn-quickview")) {
                      destinationElmMobile.querySelector(".label-btn-quickview").style.display="none";
                    }
                  }
                }
                document.dispatchEvent(new CustomEvent("eurus:quickview:loaded", {
                  detail: {
                    productUrl: url
                  }
                }));  
              });
            }
            this.loadingChooseOption = false;
          } catch (error) {
            console.log(error);
          }
        }, 0)
      },
      open(isMiniCart = false) {
        const activeElement = document.activeElement;
        this.triggerElement = activeElement instanceof HTMLElement && activeElement !== document.body
          ? activeElement
          : this.buttonQuickView;
        this.isMiniCart = isMiniCart;
        const popup = Alpine.store('xPopup');
        popup.cancelClose();
        popup.open = true;
        this.resetScrollPosition();
        this.show = true;
        this.startTouchContainment(document.getElementById('QuickView'));
        document.dispatchEvent(new CustomEvent("eurus:quickview:open"));
      },
      close() {
        const triggerElement = this.triggerElement;
        this.stopTouchContainment();
        this.show = false;
        this.buttonQuickView = '';
        if(!Alpine.store('xMiniCart').open) {
          Alpine.store('xPopup').close();
        }
        this.triggerElement = null;
        this.isMiniCart = false;
        this.restoreFocus(triggerElement);
      },
      closePopupMobile() {
        const triggerElement = this.chooseOptionsTrigger;
        this.openPopupMobile = false;
        this.chooseOptionsTrigger = null;
        if (!this.show && !Alpine.store('xMiniCart').open) {
          Alpine.store('xPopup').close();
        }
        this.restoreFocus(triggerElement);
      },
      showChooseOption(id, el) {
        this.chooseOptionsTrigger = el;
        this.openPopupMobile = true;
        if (window.xViewport.innerWidth < 768) {
          const popup = Alpine.store('xPopup');
          popup.cancelClose();
          popup.open = true;
        }
        const product = el.closest(".card-product");
        const addToCartBtn = product.querySelector('.choose-options')?.querySelector('.add_to_cart_button');
        const iconAddToCartBtn = product.querySelector('.choose-options')?.querySelector('.label-btn-quickview')
        const addToCartBtnMobile = document.querySelector('.choose-options-mobile')?.querySelector('.add_to_cart_button');
        const iconAddToCartBtnMobile = document.querySelector('.choose-options-mobile')?.querySelector('.label-btn-quickview')

        if(addToCartBtn && iconAddToCartBtn && window.xViewport.innerWidth > 767){
          addToCartBtn.style.display="block"
          iconAddToCartBtn.style.display="none"
        }else if(addToCartBtnMobile && iconAddToCartBtnMobile){
          addToCartBtnMobile.style.display="block"     
          iconAddToCartBtnMobile.style.display="none"
        }
        document.dispatchEvent(new CustomEvent("eurus:quickview:open"));       
      },
      clickInsideQuickView(evt, $el) {
        if(this.isMiniCart) {
          evt.stopPropagation();
          this.close();
        }
      },
      clickInsideContentQuickView(evt) {
        evt.stopPropagation();
      },
      startTouchContainment(modal) {
        if (
          this.touchMoveHandler
          || !modal
          || !window.matchMedia('(max-width: 767px)').matches
        ) return;

        this.touchLockElement = modal;
        this.touchStartHandler = (event) => {
          if (event.touches.length !== 1) return;
          this.touchStartX = event.touches[0].clientX;
          this.touchStartY = event.touches[0].clientY;
        };
        this.touchMoveHandler = (event) => {
          if (!this.show || event.touches.length !== 1) return;

          const touch = event.touches[0];
          const deltaX = touch.clientX - this.touchStartX;
          const deltaY = touch.clientY - this.touchStartY;
          this.touchStartX = touch.clientX;
          this.touchStartY = touch.clientY;

          if (Math.abs(deltaX) > Math.abs(deltaY)) return;

          const target = event.target instanceof Element ? event.target : null;
          const scroller = target?.closest('.product-content-container');
          if (!scroller || !modal.contains(scroller)) {
            event.preventDefault();
            return;
          }

          const atTop = scroller.scrollTop <= 0;
          const atBottom = Math.ceil(scroller.scrollTop + scroller.clientHeight) >= scroller.scrollHeight;
          const cannotScroll = scroller.scrollHeight <= scroller.clientHeight;
          if (cannotScroll || (atTop && deltaY > 0) || (atBottom && deltaY < 0)) {
            event.preventDefault();
          }
        };

        modal.addEventListener('touchstart', this.touchStartHandler, { passive: true });
        modal.addEventListener('touchmove', this.touchMoveHandler, { passive: false });
      },
      stopTouchContainment() {
        if (!this.touchLockElement) return;

        this.touchLockElement.removeEventListener('touchstart', this.touchStartHandler);
        this.touchLockElement.removeEventListener('touchmove', this.touchMoveHandler);
        this.touchLockElement = null;
        this.touchStartHandler = null;
        this.touchMoveHandler = null;
      },
      restoreFocus(element) {
        if (!element || !element.isConnected || typeof element.focus !== 'function') return;
        requestAnimationFrame(() => {
          element.focus({ preventScroll: true });
        });
      }
    });
  });
});
